import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import './MultiInputNumber.css';
import PhoneInput2 from 'react-phone-input-2';
import parsePhoneNumber from 'libphonenumber-js';
import { toast } from 'react-toastify';

class MultiInputNumber extends Component {
  constructor(props) {
    super(props);
    this.state = {
      currentValue: '',
      invalidValue: false,
    };
  }

  onInputChange = ev => {
    let currentValue = ev.target.value.toLowerCase();
    this.setState({
      currentValue: ev,
    });
  };

  onValuesChange = values => {
    const { onChange } = this.props;
    onChange(values);
  };

  addValue = () => {
    const { currentValue } = this.state;
    const { validator, inputData } = this.props;
    currentValue = currentValue.trim().toLowerCase();

    const phoneNumber = parsePhoneNumber(currentValue, 'US');
    if (phoneNumber.isValid() === true) {
      if (!validator(currentValue)) {
        this.setState({
          invalidValue: true,
        });
        return;
      }
      if (inputData.find(val => val === currentValue)) {
        this.setState({
          invalidValue: true,
        });
        return;
      }
      const newValues = [...inputData, currentValue];
      this.setState({
        currentValue: '',
        invalidValue: false,
      });
      this.onValuesChange(newValues);
    } else {
      toast.error('Please enter valid US/Canada number.');
    }
  };

  onKeyPress = ev => {
    const keyCode = typeof ev.which === 'number' ? ev.which : ev.keyCode;
    // Enter key
    if (keyCode === 13) {
      const { currentValue } = this.state;
      if (!currentValue) {
        return;
      }
      this.addValue();
      return;
    }
    // Escape key
    if (keyCode === 27) {
      this.setState({
        currentValue: '',
        invalidValue: false,
      });
    }
  };

  removeValue = index => {
    const { inputData } = this.props;
    const valuesWIthRemoved = inputData.filter((val, ind) => ind !== index);
    this.onValuesChange(valuesWIthRemoved);
  };

  renderEmails = () => {
    const { inputData, disabledAdmin } = this.props;
    return inputData.map((value, ind) => {
      return (
        // <span className="item">{value},</span>
        <div className="multi-input-item" key={value}>
          <span className="item">{value}</span>
          {/* <img
            className="remove-icon"
            src={remove}
            onClick={() => (!disabledAdmin ? this.removeValue(ind) : null)}
            alt="remove"
          /> */}
        </div>
      );
    });
  };

  render() {
    const { currentValue, invalidValue } = this.state;
    const { disabledAdmin, placeholder } = this.props;
    return (
      <div className="multi-input-port">
        <div className="input-container">
          <div style={{ width: '100%' }}>
            <PhoneInput2
              inputExtraProps={{ name: 'number' }}
              value={currentValue}
              onKeyDown={this.onKeyPress}
              onChange={this.onInputChange}
            />
          </div>
          <span className="multi-input-control-indicator">
            {currentValue.length ? (
              <FontAwesomeIcon
                color="#f15931"
                className="enter-indicator"
                icon="plus"
                size="xs"
                onClick={this.addValue}
              />
            ) : (
              ''
            )}
          </span>
        </div>
        <div className="multi-input-info">
          Type a value and press <strong>enter</strong> to add to the list
        </div>
        <div className="email-list">{this.renderEmails()}</div>
      </div>
    );
  }
}

MultiInputNumber.propTypes = {
  validator: PropTypes.func,
  inputData: PropTypes.arrayOf(PropTypes.string),
  onChange: PropTypes.func,
};

MultiInputNumber.defaultProps = {
  validator: () => true,
  onChange: () => {},
  inputData: [],
};

export default MultiInputNumber;
